import { useEffect } from 'react'

import { PageProps } from '@/@types/global'
import { useApp } from '@/stores/AppStore'

export const usePageTitle = ({
  title,
  subtitle = null,
  actions = null,
}: PageProps) => {
  const { setPageTitle, setPageSubTitle, setPageActions } = useApp()

  useEffect(() => {
    setPageTitle(title)
    subtitle && setPageSubTitle(subtitle)
    actions && setPageActions(actions)

    return () => {
      setPageTitle(null)
      subtitle && setPageSubTitle(null)
      actions && setPageActions(null)
    }
  }, [setPageTitle, setPageSubTitle, setPageActions, title, subtitle, actions])
}
